<template>
  <TopbarSpeedDial :buttons="buttons" :routeKey="routeKey" />
</template>


<script>
/* @flow */
const TopbarSpeedDial = () =>
  import(/* webpackChunkName: "TopbarSpeedDial" */ '@/components/TopbarSpeedDial')

export default {
  name: 'ApplicationNetworkSpeedDial',
  props: {
    routeName: {type: String, default: ''},
    routeKey: {type: String, default: ''},
  },
  data() {
    return {
      buttonsConfig: [
        {
          label: 'Create new application network',
          icon: 'add',
          colorClass: 'accent',
          showForListScreen: true,
          to: 'new',
        },
      ],
    }
  },
  computed: {
    buttons: function() {
      if (this.routeName.startsWith('ApplicationNetworks')) {
        return this.buttonsConfig.filter(btn => btn.showForListScreen)
      } else {
        return this.buttonsConfig
      }
    },
  },
  components: {
    TopbarSpeedDial,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ApplicationNetworkSpeedDial.vue